.thumbnail {
  position: absolute;
  bottom: 50px;
  width: var(--thumbnail-width);
  border: 2px solid var(--rds-foreground-primary);
  border-radius: var(--rds-roundness--default);
  padding: 2px;
}

.hide {
  display: none;
}
